import { Row as AntRow } from 'antd';
import styled from 'styled-components';

export const Row = styled(AntRow)``;
